export enum ChecklistTimeSettings {
    Recurring = 1,
    OneTime = 2,
}
